import { getListItem } from "../";
import { sortList } from "../";

import {
  ALERT_RESET_COMPOSE,
  ALERT_SEARCH_LIST_CHANGED,
  ALERT_TOGGLE_RIGHTPANEL,
  ALERT_TOGGLE_SEARCHBAR,
  ALERT_UPDATE_COMPOSE_DATA,
  ALERT_UPDATE_DATA_LIST,
  ALERT_UPDATE_LIST,
  ALERT_UPDATE_LIST_ITEM,
  ALERT_UPDATE_LIST_ITEM_TYPE,
  ALERT_UPDATE_NODE,
  ALERT_UPDATE_TAB_ID,
  ALERT_UPDATE_TAB_NUM
} from "./types";

import { toggleWarning } from "./alerts-api";

export const changedTabs = (ref: any) => {
  const { dispatch, list, listItemType, tabId } = ref;
  updateTabs({ dispatch, tabId });
  updateList({ dispatch, list, tabId });
  updateListItemType({ dispatch, listItemType });
};

const updateTabs = (ref: any) => {
  const { dispatch, tabId } = ref;
  
  let tabNum;

  switch(tabId){
    case 'active': 
      tabNum = 0;
      break;
    case 'expired':
      tabNum = 1;
      break;
    case 'cancelled':
      tabNum = 2;
      break;
    case 'drafts':
      tabNum = 3;
      break;
    case 'scheduled':
      tabNum = 4;
      break;
    default:
      break;
  }
  
  dispatch({ type: ALERT_UPDATE_TAB_NUM, payload: tabNum });
  dispatch({ type: ALERT_UPDATE_TAB_ID, payload: tabId });
};

export const updateList = (ref: any) => {
  const { dispatch, tabId } = ref;
  let { list } = ref;

  if (list) {
    list = list.filter((element: any, index: any) => {
      return element.type === tabId;
    });
  }

  list = sortList(list);

  dispatch({ type: ALERT_UPDATE_LIST, payload: list });
};

export const updateListItemType = (ref: any) => {
  const { dispatch, listItemType } = ref;
  dispatch({ type: ALERT_UPDATE_LIST_ITEM_TYPE, payload: listItemType });
};

export const handleCollapse = (ref: any) => {
  const { nodeData, warningActive } = ref;
  const selected = nodeData.isSelected;
  if (!selected && !warningActive) {
    nodeData.isExpanded = false;
  }
};

export const handleExpand = (ref: any) => {
  const { nodeData } = ref;
  if (nodeData.childNodes && nodeData.childNodes.length > 0) {
    nodeData.isExpanded = true;
  }
};

export const rowClicked = (ref: any) => {
  const { dispatch, data, history, nodeData, tabId } = ref;
  const list = data.list;
  const listItem = getListItem(list, nodeData.id);
  const pathname = history.location.pathname;

  const callback = () => {
    updateNode({ dispatch, nodeData, list });
    updateListItem({ dispatch, listItem });
    history.push("/alerts/dashboard");
  };

  if (nodeData.childNodes && nodeData.isExpanded && nodeData.isSelected) {
    updateNode({ dispatch, nodeData, list });
    history.push("/alerts");
  } else if (
    nodeData.childNodes &&
    (!nodeData.isExpanded || nodeData.isSelected)
  ) {
    updateNode({ dispatch, nodeData, list });
    updateList({ dispatch, list, tabId });
  } else if (pathname.includes("compose")) {
    hideCompose({ dispatch, history, callback });
  } else if (!nodeData.isSelected) {
    updateNode({ dispatch, nodeData, list });
    updateListItem({ dispatch, listItem });
    history.push("/alerts/dashboard");
  }
};

export const composeRowClicked = (ref: any) => {
  const { dispatch, history, data, nodeData, tabId } = ref;
  const list = data.list;
  const callback = () => {
    updateNode({ dispatch, nodeData, list });
    updateComposeData({ dispatch, nodeData });
    history.push("/alerts/compose");
  };

  if (nodeData.childNodes && nodeData.isExpanded && nodeData.isSelected) {
    updateNode({ dispatch, nodeData, list });
    history.push("/alerts");
  } else if (
    nodeData.childNodes &&
    (!nodeData.isExpanded || nodeData.isSelected)
  ) {
    updateNode({ dispatch, nodeData, list });
    updateList({ dispatch, list, tabId });
  } else if (!nodeData.isSelected) {
    showCompose({ dispatch, history, callback });
  }
};

export const resetCompose = (ref: any) => {
  const { dispatch } = ref;
  dispatch({
    type: ALERT_RESET_COMPOSE
  });
};

function forEachNode(nodes: Array<any>, callback: (node: any) => void) {
  if (nodes == null) {
    return;
  }
  for (const node of nodes) {
    callback(node);
    forEachNode(node.childNodes || [], callback);
  }
}

export const updateNode = (ref: any) => {
  const { dispatch, nodeData } = ref;
  const { list } = ref;
  const originallySelected = nodeData.isSelected;
  let hasChildren = false;

  if (nodeData && nodeData.childNodes) {
    hasChildren = nodeData.childNodes.length > 0;
  }

  forEachNode(list, n => (n.isSelected = false));

  if (hasChildren) {
    if (!nodeData.isExpanded) {
      nodeData.isSelected = false;
    } else {
      nodeData.isSelected =
        originallySelected == null ? true : !originallySelected;
    }
  } else {
    nodeData.isSelected = true;
  }
  dispatch({
    type: ALERT_UPDATE_NODE,
    payload: nodeData
  });
};

const updateListItem = (ref: any) => {
  const { dispatch, listItem } = ref;
  dispatch({
    type: ALERT_UPDATE_LIST_ITEM,
    payload: listItem
  });
};

const updateComposeData = (ref: any) => {
  const { dispatch, nodeData } = ref;

  dispatch({
    type: ALERT_UPDATE_COMPOSE_DATA,
    payload: nodeData.listData
  });
};

export const hideCompose = (ref: any) => {
  const { dispatch, history, callback, nodeData } = ref;
  const pathname = history.location.pathname;

  const defaultCallback = () => {
    resetCompose({ dispatch });
    if (nodeData) {
      nodeData.isSelected = false;
      nodeData.isExpanded = false;
    }
    toggleRightPanel({ dispatch, rightPanelExpanded: true });
    history.push("/alerts");
  };

  if (pathname.includes("compose")) {
    const warningContent = {
      header: "Are you sure you want to leave?",
      body: "All your changes will be discarded"
    };
    if (callback) {
      toggleWarning({ dispatch, warningContent, callback });
    } else {
      toggleWarning({ dispatch, warningContent, callback: defaultCallback });
    }
  }
};

export const showCompose = (ref: any) => {
  const { dispatch, history, callback, nodeData } = ref;
  const pathname = history.location.pathname;

  const defaultCallback = () => {
    resetCompose({ dispatch });
    if (nodeData) {
      nodeData.isSelected = false;
      nodeData.isExpanded = false;
    }
    updateListItem({ dispatch, listItem: null });
    history.push("/alerts/compose");
  };

  if (pathname.includes("compose")) {
    const warningContent = {
      header: "Warning!",
      body: "All your changes will be discarded"
    };
    if (callback) {
      toggleWarning({ dispatch, warningContent, callback });
    } else {
      toggleWarning({ dispatch, warningContent, callback: defaultCallback });
    }
  } else {
    resetCompose({ dispatch });
    if (callback) {
      callback();
    } else {
      defaultCallback();
    }
  }
};

export const closeRightPanel = (ref: any) => {
  const { nodeData,  tabId, history } = ref;
  // const list = data.list;
  nodeData.isSelected = false;
  nodeData.isExpanded = false;
  console.log(tabId, 'tabID')
  history.push("/alerts");
};

export const toggleRightPanel = (ref: any) => {
  const { dispatch, rightPanelExpanded } = ref;
  dispatch({
    type: ALERT_TOGGLE_RIGHTPANEL,
    payload: !rightPanelExpanded
  });
};

export const toggleSearchBar = (ref: any) => {
  const { dispatch, searchBarActive, list, tabId } = ref;
  dispatch({
    type: ALERT_TOGGLE_SEARCHBAR,
    payload: !searchBarActive
  });
  if (searchBarActive) {
    searchChanged({ dispatch, value: "", list, tabId });
  }
};

export const searchChanged = (ref: any) => {
  const { dispatch, tabId, list } = ref;
  const { value } = ref;

  updateSearchLists({ dispatch, list, tabId, value });

  dispatch({
    type: ALERT_SEARCH_LIST_CHANGED,
    payload: value
  });
};

const updateSearchLists = (ref: any) => {
  const { dispatch, list } = ref;
  let { value } = ref;
  value = value.toLowerCase();
  let searchLists;
  let partitionedObj;
  const partitionedLists = [];
  if (list) {
    searchLists = list.filter((element: any, index: any) => {
      const listData = element.listData;
      let { type, title, description } = listData;
      type = type.toLowerCase();
      title = title.toLowerCase();
      description = description.toLowerCase();
      return (
        type.includes(value) ||
        title.includes(value) ||
        description.includes(value)
      );
    });

    partitionedObj = searchLists.reduce((res: any, element: any) => {
      const key = element.type;
      if (res[key]) {
        res[key].push(element);
      } else {
        res[key] = [element];
      }
      return res;
    }, {});

    const keys = Object.keys(partitionedObj);

    for (let i = 0; i < keys.length; i++) {
      partitionedLists.push(partitionedObj[keys[i]]);
    }
  }

  if (value.length > 0) {
    updateList({ dispatch, list: partitionedLists, tabId: undefined });
  } else {
    updateList({ dispatch, list, tabId: "active" });
  }
};

export const removeFromList = (ref: any) => {
  const { dispatch, nodeData, tabId, composeData } = ref;
  let { list } = ref;

  if (nodeData) {
    list = list.filter((value: any) => {
      return value.id !== nodeData.id;
    });

    updateDataList({ dispatch, list });
    updateList({ dispatch, list, tabId });
    resetCompose({ dispatch, composeData });
  }
};

export const updateDataList = (ref: any) => {
  const { dispatch, list } = ref;
  dispatch({ type: ALERT_UPDATE_DATA_LIST, payload: list });
};

export const appendToList = (ref: any) => {
  const { dispatch, data, tabId, type, list } = ref;

  const listItem = {
    id: list.length.toString() + 1,
    type,
    listData: data
  };

  const indexFound =
    list.filter((value: any, index: any) => {
      if (value.id === data.id) {
        return index;
      }
    }).length > 0;

  if (!indexFound) {
    list.push(listItem);
  }

  if (tabId === type) {
    updateList({ dispatch, list, tabId });
  }
};



// WEBPACK FOOTER //
// ./src/actions/alerts/alerts-list-api.tsx